import { useCallback } from 'react';
import { selectAppDomain, useAppSelector } from '@ibk/shared-config';
import { AppDomain } from '@ibk/shared-types';
import { useValidateAccountantOrderSpreadsheetMutation, useValidateClientOrderSpreadsheetMutation, } from '../services/orderSpreadsheetApi';
export function useEmissorValidateOrderSpreadsheet() {
    const appDomain = useAppSelector(selectAppDomain);
    const isAccountant = appDomain === AppDomain.ESCRITORIO;
    const [validateAccountant, accountantState] = useValidateAccountantOrderSpreadsheetMutation();
    const [validateClient, clientState] = useValidateClientOrderSpreadsheetMutation();
    const trigger = isAccountant ? validateAccountant : validateClient;
    const isValidating = isAccountant ? accountantState.isLoading : clientState.isLoading;
    const validateSpreadsheet = useCallback((args) => trigger(args).unwrap(), [trigger]);
    return { validateSpreadsheet, isValidating };
}
